<template>
  <b-steps ref="steps"
   type="is-primary" :has-navigation="hasNavigation" v-model="activeStep" @input="setStep" size="is-large">
    <template v-for="(step, index) in baseSteps">
      <b-step-item :key="index"
                   :label="step.label"
                   :icon="step.icon"
                   :value="step.stepValue.toString()"
                   :visible="step.visible"
                   :clickable ="step.clickable"
                   >
      </b-step-item>
    </template>
  </b-steps>
</template>

<script>
import {
  mapGetters,
} from 'vuex';

export default {
  name: 'DesktopProgressBar',
  data() {
    return {
      step: 0,
      hasAttachedEnterEvents: false,
    };
  },
  props: {
    hasNavigation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['getAreaName', 'desktopSteps', 'stepsProgress']),
    activeStep: {
      get() {
        return this.stepsProgress;
      },
      set(step) {
        this.step = step;
      },
    },
    baseSteps() {
      return this.desktopSteps;
    },
  },
  updated() {
    this.setEnterKeyEventHandlers();
    this.setTabs();
  },
  methods: {
    setStep(stepValue) {
      const newAreaName = this.getAreaName(stepValue);
      this.$emit('changeStep', newAreaName);
    },
    setEnterKeyEventHandlers() {
      if (this.hasAttachedEnterEvents === true) { return; }
      const steps = this.$refs.steps.$el.querySelectorAll('a.step-link');
      steps.forEach((element) => {
        const step = element;
        step.addEventListener('keyup', (event) => {
          // Number 13 is the "Enter" key on the keyboard
          if (event.keyCode === 13) { step.click(); }
        });
      });
      this.hasAttachedEnterEvents = true;
    },
    setTabs() {
      const steps = this.$refs.steps.$el.querySelectorAll('a.step-link');
      steps.forEach((element) => {
        const step = element;
        if (element.classList.contains('is-clickable')) {
          step.tabIndex = 0;
        } else {
          step.tabIndex = -1;
        }
      });
    },
  },
};
</script>
